import { useQrCodesStore} from "@/store/qrCodes";
import { defineStore, storeToRefs } from "pinia";

import { useStatesStore } from "@/store/states.js";

export const useQrCodeHomepageStore = defineStore('qrCodeHomepage', () => {
    const statesStore = useStatesStore();
    const qrCodeStore = useQrCodesStore();
    const { qrCode } = storeToRefs(qrCodeStore);

    const { loading, validationErrors } = storeToRefs(statesStore);

    const updateHomepage = async () => {
        if (! qrCode.value || ! qrCode.value.homepage) {
            return false;
        }

        loading.value = true;

        try {
            const { data } = await axios.put(`/api/qr-codes/${qrCode.value.id}/homepage`, qrCode.value.homepage);
            await statesStore.onSuccess();
            qrCode.value = data.data;
            return true;
        } catch (error) {
            validationErrors.value = error.response?.data?.errors ?? {};
            await statesStore.onFail();
            return false;
        }
    };

    const updateContent = async (id, payload) => {
        if (! qrCode.value) {
            return;
        }

        loading.value = true;

        try {
            const { data } = await axios.put(`/api/qr-codes/${qrCode.value.id}/homepage/${id}`, payload);
            await statesStore.onSuccess();
            qrCode.value = data.data;
        } catch (error) {
            validationErrors.value = error.response.data.errors;
            await statesStore.onFail();
        }
    };

    const updateBackground = async (backgroundId) => {
        if (! qrCode.value?.homepage) {
            return false;
        }

        loading.value = true;

        try {
            const { data } = await axios.put(
                `/api/qr-codes/${qrCode.value.id}/homepage/background`,
                { homepage_background_id: backgroundId },
            );
            await statesStore.onSuccess();
            qrCode.value = data.data;
            return true;
        } catch (error) {
            validationErrors.value = error.response?.data?.errors ?? {};
            await statesStore.onFail();
            return false;
        }
    };

    const deleteFile = async (homepageId, fileId) => {
        if (! qrCode.value) {
            return;
        }

        try {
            const { data } = await axios.delete(`/api/qr-codes/${qrCode.value.id}/homepage/${homepageId}/files/${fileId}`);
            return data.data;
        } catch (error) {
            await statesStore.onFail();
        }
    };

    const create = async (payload) => {
        loading.value = true;
        let data;

        try {
            data = await axios.post(`/api/qr-codes/${qrCode.value.id}/homepage`, payload);
            await statesStore.onSuccess();
        } catch (error) {
            validationErrors.value = error.response.data.errors;
            await statesStore.onFail();
            return;
        }

        await qrCodeStore.fetchOne(qrCode.value.id, true);

        return data.data;
    };

    const setContentsOrder = async () => {
        const payload = {
            contents: qrCode.value.homepage.contents.map(content => content.id)
        };

        try {
            await axios.post(`/api/qr-codes/${qrCode.value.id}/homepage/order`, payload);
        } catch (error) {
            //
        }
    };

    const remove = async (id) => {
        loading.value = true;

        try {
            const { data } = await axios.delete(`/api/qr-codes/${qrCode.value.id}/homepage/${id}`);
            await statesStore.onSuccess();
            qrCode.value = data.data;
        } catch (error) {
            validationErrors.value = error.response.data.errors;
            await statesStore.onFail();
        }
    };

    const deleteMainImage = async () => {
        loading.value = true;
        try {
            await axios.delete(`/api/qr-codes/${qrCode.value.id}/homepage/main-image`);
            await statesStore.onSuccess();
            qrCode.value.homepage.main_image_file = null;
        } catch (error) {
            await statesStore.onFail();
        }
    };

    return {
        loading,
        create,
        updateHomepage,
        updateBackground,
        updateContent,
        remove,
        deleteFile,
        deleteMainImage,
        setContentsOrder,
    }
})
